import Swiper from "swiper";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

export function initHeroSlider() {
    const heroSliders = document.querySelectorAll(".pul-header .swiper");

    if (heroSliders.length > 0) {
        for (const heroSlider of heroSliders) {
            const slider = new Swiper(heroSlider, {
                modules: [Autoplay, Pagination, EffectFade],
                rewind: true,
                effect: "fade",
                autoplay: {
                    delay: 5000,
                    pauseOnMouseEnter: true
                },
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    afterInit: swiper => {
                        handlePaginationColor(swiper);
                        playVideo(swiper)
                    },
                    slideChangeTransitionEnd: swiper => {
                        playVideo(swiper)
                    },
                    beforeTransitionStart: swiper => {
                        handlePaginationColor(swiper);
                        pauseVideo(swiper);
                    }
                }
            });
        }
    }
}

function handlePaginationColor(swiper) {
    const swiperWrapper = swiper.hostEl;
    const activeSlideColor = swiper.slides[swiper.realIndex].classList.contains("text-white");

    if (activeSlideColor) {
        swiperWrapper.style.setProperty("--swiper-pagination-bullet-inactive-color", getComputedStyle(document.documentElement).getPropertyValue("--clr-white"));
        swiperWrapper.style.setProperty("--swiper-pagination-color", getComputedStyle(document.documentElement).getPropertyValue("--clr-white"));
    } else {
        swiperWrapper.style.setProperty("--swiper-pagination-bullet-inactive-color", getComputedStyle(document.documentElement).getPropertyValue("--clr-primary-blue"));
        swiperWrapper.style.setProperty("--swiper-pagination-color", getComputedStyle(document.documentElement).getPropertyValue("--clr-primary-blue"));
    }

}

function playVideo(swiper) {
    const video = swiper.slides[swiper.realIndex].querySelector("video");

    if(video) {
        const timeout = setTimeout(() => {
            video.play()
            clearTimeout(timeout);
        },10)
    }
}

function pauseVideo(swiper) {
    const video = swiper.slides[swiper.realIndex].querySelector("video");

    if(video) video.pause();
}

// function handleAutoplayvideo(swiper) {
//     const video = swiper.slides[swiper.realIndex].querySelector("video");

//     console.log(video)

//     // if (!video) return;

//     // if (video.paused) {
//     //     video.play();
//     // } else {
//     //     video.pause();
//     // }
// }